/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Empty_TitleInputs */

const en_recipes_empty_title = /** @type {(inputs: Recipes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your cookbook is empty`)
};

const de_recipes_empty_title = /** @type {(inputs: Recipes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kochbuch ist leer`)
};

/**
* | output |
* | --- |
* | "Your cookbook is empty" |
*
* @param {Recipes_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_empty_title = /** @type {((inputs?: Recipes_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_empty_title(inputs)
	return en_recipes_empty_title(inputs)
});